"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ConvertColor;
var _colorLibrary = require("./color-library");
var _compare = _interopRequireDefault(require("./compare"));
var _utils = require("./utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Calculate the Euclidean distance between two RGB colors
 * @param rgb1 First RGB color
 * @param rgb2 Second RGB color
 * @returns The Euclidean distance between the two colors
 */
function calculateDistance(rgb1, rgb2) {
  const {
    r: r1,
    g: g1,
    b: b1
  } = rgb1;
  const {
    r: r2,
    g: g2,
    b: b2
  } = rgb2;
  return Math.sqrt((r2 - r1) ** 2 + (g2 - g1) ** 2 + (b2 - b1) ** 2);
}
const colorConvert = {
  cmyk: {
    hex6(cmyk) {
      const rgb = this.rgb(cmyk);
      return colorConvert.rgb.hex6(rgb);
    },
    hsl(cmyk) {
      const rgb = this.rgb(cmyk);
      return colorConvert.rgb.hsl(rgb);
    },
    hsv(cmyk) {
      const rgb = this.rgb(cmyk);
      return colorConvert.rgb.hsv(rgb);
    },
    pantone(cmyk) {
      const rgb = this.rgb(cmyk);
      return colorConvert.rgb.pantone(rgb);
    },
    rgb(cmyk) {
      return {
        r: Math.round(255 * (1 - cmyk.c / 100) * (1 - cmyk.k / 100)),
        g: Math.round(255 * (1 - cmyk.m / 100) * (1 - cmyk.k / 100)),
        b: Math.round(255 * (1 - cmyk.y / 100) * (1 - cmyk.k / 100))
      };
    }
  },
  hex3: {
    cmyk(hex3) {
      const rgb = this.rgb(hex3);
      return colorConvert.rgb.cmyk(rgb);
    },
    hex6(hex3) {
      return {
        value: _utils.stringUtils.doubleString(hex3.value)
      };
    },
    hsl(hex3) {
      const rgb = this.rgb(hex3);
      return colorConvert.rgb.hsl(rgb);
    },
    hsv(hex3) {
      const rgb = this.rgb(hex3);
      return colorConvert.rgb.hsv(rgb);
    },
    pantone(hex3) {
      const rgb = this.rgb(hex3);
      return colorConvert.rgb.pantone(rgb);
    },
    rgb(hex3) {
      const hex6 = this.hex6(hex3);
      return {
        r: parseInt(hex6.value.substring(0, 2), 16),
        g: parseInt(hex6.value.substring(2, 4), 16),
        b: parseInt(hex6.value.substring(4, 6), 16)
      };
    }
  },
  hex6: {
    cmyk(hex6) {
      const rgb = this.rgb(hex6);
      return colorConvert.rgb.cmyk(rgb);
    },
    hex3(hex6) {
      function convertor(a, b) {
        const temp = Math.floor(parseInt([a, b].join(''), 16) / 16);
        return temp.toString(16);
      }
      return {
        value: convertor(hex6.value[0], hex6.value[1]) + convertor(hex6.value[2], hex6.value[3]) + convertor(hex6.value[4], hex6.value[5])
      };
    },
    hsl(hex6) {
      const rgb = this.rgb(hex6);
      return colorConvert.rgb.hsl(rgb);
    },
    hsv(hex6) {
      const rgb = this.rgb(hex6);
      return colorConvert.rgb.hsv(rgb);
    },
    pantone(hex6) {
      const rgb = this.rgb(hex6);
      return colorConvert.rgb.pantone(rgb);
    },
    rgb(hex6) {
      return {
        r: parseInt(hex6.value.substring(0, 2), 16),
        g: parseInt(hex6.value.substring(2, 4), 16),
        b: parseInt(hex6.value.substring(4, 6), 16)
      };
    }
  },
  hsl: {
    cmyk(hsl) {
      const rgb = this.rgb(hsl);
      return colorConvert.rgb.cmyk(rgb);
    },
    hex6(hsl) {
      const rgb = this.rgb(hsl);
      return colorConvert.rgb.hex6(rgb);
    },
    hsv(hsl) {
      const rgb = this.rgb(hsl);
      return colorConvert.rgb.hsv(rgb);
    },
    pantone(hsl) {
      const rgb = this.rgb(hsl);
      return colorConvert.rgb.pantone(rgb);
    },
    rgb(hsl) {
      const newHSL = {
        ...hsl
      };
      const rgb = {
        r: 0,
        g: 0,
        b: 0
      };
      newHSL.h /= 60;
      if (newHSL.h < 0) {
        newHSL.h = 6 - -newHSL.h % 6;
      }
      newHSL.h %= 6;
      newHSL.s = Math.max(0, Math.min(1, newHSL.s / 100));
      newHSL.l = Math.max(0, Math.min(1, newHSL.l / 100));
      const hslC = (1 - Math.abs(2 * newHSL.l - 1)) * newHSL.s;
      const hslX = hslC * (1 - Math.abs(newHSL.h % 2 - 1));
      if (newHSL.h < 1) {
        rgb.r = hslC;
        rgb.g = hslX;
      } else if (newHSL.h < 2) {
        rgb.r = hslX;
        rgb.g = hslC;
      } else if (newHSL.h < 3) {
        rgb.g = hslC;
        rgb.b = hslX;
      } else if (newHSL.h < 4) {
        rgb.g = hslX;
        rgb.b = hslC;
      } else if (newHSL.h < 5) {
        rgb.r = hslX;
        rgb.b = hslC;
      } else {
        rgb.r = hslC;
        rgb.b = hslX;
      }
      const hslM = newHSL.l - hslC / 2;
      const rgbKeys = Object.keys(rgb);
      // eslint-disable-next-line no-restricted-syntax
      for (const rgbKey of rgbKeys) {
        rgb[rgbKey] = Math.round((rgb[rgbKey] + hslM) * 255);
      }
      return rgb;
    }
  },
  hsv: {
    cmyk(hsv) {
      const rgb = this.rgb(hsv);
      return colorConvert.rgb.cmyk(rgb);
    },
    hex6(hsv) {
      const rgb = this.rgb(hsv);
      return colorConvert.rgb.hex6(rgb);
    },
    hsl(hsv) {
      const rgb = this.rgb(hsv);
      return colorConvert.rgb.hsl(rgb);
    },
    pantone(hsv) {
      const rgb = this.rgb(hsv);
      return colorConvert.rgb.pantone(rgb);
    },
    rgb(hsv) {
      const newHSV = {
        ...hsv
      };
      newHSV.h /= 360;
      newHSV.s /= 100;
      newHSV.v /= 100;
      const i = Math.floor(newHSV.h * 6);
      const f = newHSV.h * 6 - i;
      const p = newHSV.v * (1 - newHSV.s);
      const q = newHSV.v * (1 - f * newHSV.s);
      const t = newHSV.v * (1 - (1 - f) * newHSV.s);
      switch (i % 6) {
        case 0:
          return {
            r: Math.round(newHSV.v * 255),
            g: Math.round(t * 255),
            b: Math.round(p * 255)
          };
        case 1:
          return {
            r: Math.round(q * 255),
            g: Math.round(newHSV.v * 255),
            b: Math.round(p * 255)
          };
        case 2:
          return {
            r: Math.round(p * 255),
            g: Math.round(newHSV.v * 255),
            b: Math.round(t * 255)
          };
        case 3:
          return {
            r: Math.round(p * 255),
            g: Math.round(q * 255),
            b: Math.round(newHSV.v * 255)
          };
        case 4:
          return {
            r: Math.round(t * 255),
            g: Math.round(p * 255),
            b: Math.round(newHSV.v * 255)
          };
        case 5:
          return {
            r: Math.round(newHSV.v * 255),
            g: Math.round(p * 255),
            b: Math.round(q * 255)
          };
        default:
          break;
      }
      throw new Error(`Invalid HSV value: ${newHSV}`);
    }
  },
  lab: {
    pantone(labOrigin) {
      const rgb = this.rgb(labOrigin);
      return colorConvert.rgb.pantone(rgb);
    },
    ral(lab) {
      const ralResult = {
        index: 768,
        position: _colorLibrary.ral.length - 1
      };
      // eslint-disable-next-line no-restricted-syntax
      for (const elementRal of _colorLibrary.ral) {
        const t = (0, _compare.default)({
          c1: {
            ...elementRal.lab,
            __name: 'lab'
          },
          c2: {
            ...lab,
            __name: 'lab'
          },
          complex: true
        });
        if (t !== false && t < ralResult.index) {
          ralResult.index = t;
          ralResult.position = _colorLibrary.ral.indexOf(elementRal);
          if (ralResult.index === 0) {
            return {
              ral: _colorLibrary.ral[ralResult.position].ral,
              name: _utils.stringUtils.splitCamelCase(_colorLibrary.ral[ralResult.position].name),
              lrv: _colorLibrary.ral[ralResult.position].LRV
            };
          }
        }
      }
      return {
        ral: _colorLibrary.ral[ralResult.position].ral,
        name: _utils.stringUtils.splitCamelCase(_colorLibrary.ral[ralResult.position].name),
        lrv: _colorLibrary.ral[ralResult.position].LRV
      };
    },
    rgb(lab) {
      const xyz = {
        x: 0,
        y: 0,
        z: 0
      };
      xyz.y = (lab.l + 16) / 116;
      xyz.x = lab.a / 500 + xyz.y;
      xyz.z = xyz.y - lab.b / 200;
      xyz.x = 0.95047 * (xyz.x ** 3 > 0.008856 ? xyz.x ** 3 : (xyz.x - 16 / 116) / 7.787);
      xyz.y = 1.00000 * (xyz.y ** 3 > 0.008856 ? xyz.y ** 3 : (xyz.y - 16 / 116) / 7.787);
      xyz.z = 1.08883 * (xyz.z ** 3 > 0.008856 ? xyz.z ** 3 : (xyz.z - 16 / 116) / 7.787);
      const rgb = {
        r: 0,
        g: 0,
        b: 0
      };
      rgb.r = xyz.x * 3.2406 + xyz.y * -1.5372 + xyz.z * -0.4986;
      rgb.g = xyz.x * -0.9689 + xyz.y * 1.8758 + xyz.z * 0.0415;
      rgb.b = xyz.x * 0.0557 + xyz.y * -0.2040 + xyz.z * 1.0570;
      const rgbKeys = Object.keys(rgb);
      // eslint-disable-next-line no-restricted-syntax
      for (const rgbKey of rgbKeys) {
        rgb[rgbKey] = rgb[rgbKey] > 0.0031308 ? 1.055 * rgb[rgbKey] ** (1 / 2.4) - 0.055 : 12.92 * rgb[rgbKey];
        rgb[rgbKey] = Math.round(Math.max(0, Math.min(1, rgb[rgbKey])) * 255);
      }
      return rgb;
    }
  },
  pantone: {
    cmyk(pantoneInput) {
      const rgb = this.rgb(pantoneInput);
      return colorConvert.rgb.cmyk(rgb);
    },
    hex6(pantoneInput) {
      const rgb = this.rgb(pantoneInput);
      const hex6 = colorConvert.rgb.hex6(rgb);
      const hex6ForceAs = pantoneInput.forceAs ? colorConvert.rgb.hex6(pantoneInput.forceAs) : undefined;
      const hex6ShowAs = pantoneInput.showAs ? colorConvert.rgb.hex6(pantoneInput.showAs) : undefined;
      if (hex6ForceAs) {
        hex6.forceAs = hex6ForceAs.value;
      }
      if (hex6ShowAs) {
        hex6.showAs = hex6ShowAs.value;
      }
      return hex6;
    },
    hsl(pantoneInput) {
      const rgb = this.rgb(pantoneInput);
      return colorConvert.rgb.hsl(rgb);
    },
    hsv(pantoneInput) {
      const rgb = this.rgb(pantoneInput);
      return colorConvert.rgb.hsv(rgb);
    },
    lab(pantoneInput) {
      const rgb = this.rgb(pantoneInput);
      return colorConvert.rgb.lab(rgb);
    },
    pantone(pantoneInput) {
      const pantoneFound = _colorLibrary.pantone.find(element => element.name === pantoneInput.name);
      return pantoneFound ?? pantoneInput;
    },
    rgb(pantoneInput) {
      const pantoneFound = _colorLibrary.pantone.find(element => element.name === pantoneInput.name);
      if (pantoneFound) {
        const rgb = {
          ...pantoneFound.rgb
        };
        if (pantoneInput.forceAs) {
          rgb.forceAs = pantoneInput.forceAs;
        }
        if (pantoneInput.showAs) {
          rgb.showAs = pantoneInput.showAs;
        }
        return pantoneFound.rgb;
      }
      throw new Error(`Pantone color ${pantoneInput} not found`);
    }
  },
  ral: {
    cmyk(ralInput) {
      const ralFound = _colorLibrary.ral.find(element => element.name === ralInput || element.ral === ralInput);
      if (ralFound) {
        return ralFound.cmyk;
      }
      throw new Error(`RAL color ${ralInput} not found`);
    },
    lab(ralInput) {
      const ralFound = _colorLibrary.ral.find(element => element.name === ralInput || element.ral === ralInput);
      if (ralFound) {
        return ralFound.lab;
      }
      throw new Error(`RAL color ${ralInput} not found`);
    },
    ral(ralInput) {
      const ralFound = _colorLibrary.ral.find(element => element.name === ralInput.name || element.ral === ralInput.ral);
      if (ralFound) {
        return {
          lrv: ralFound.LRV,
          name: _utils.stringUtils.splitCamelCase(ralFound.name),
          ral: ralFound.ral
        };
      }
      return ralInput;
    },
    rgb(ralInput) {
      const ralFound = _colorLibrary.ral.find(element => element.name === ralInput || element.ral === ralInput);
      if (ralFound) {
        return ralFound.rgb;
      }
      throw new Error(`RAL color ${ralInput} not found`);
    }
  },
  rgb: {
    cmyk(rgb) {
      const cmyk = {
        c: 0,
        m: 0,
        y: 0,
        k: 0
      };
      if (rgb.r === 0 && rgb.g === 0 && rgb.b === 0) {
        cmyk.k = 100;
      } else {
        const rgbKeys = Object.keys(rgb);
        const newRGB = {
          ...rgb
        };
        // eslint-disable-next-line no-restricted-syntax
        for (const rgbKey of rgbKeys) {
          newRGB[rgbKey] /= 255;
        }
        cmyk.k = 1 - Math.max(newRGB.r, newRGB.g, newRGB.b);
        if (cmyk.k !== 1) {
          cmyk.c = (1 - newRGB.r - cmyk.k) / (1 - cmyk.k);
          cmyk.m = (1 - newRGB.g - cmyk.k) / (1 - cmyk.k);
          cmyk.y = (1 - newRGB.b - cmyk.k) / (1 - cmyk.k);
          const cmykKeys = Object.keys(cmyk);
          // eslint-disable-next-line no-restricted-syntax
          for (const cmykKey of cmykKeys) {
            cmyk[cmykKey] = Math.round(cmyk[cmykKey] * 100);
          }
        }
      }
      return cmyk;
    },
    hex6(rgb) {
      function rgbNormalize(color) {
        let hexColor = '';
        if (color < 16) {
          hexColor = `0${Number(color).toString(16)}`;
        } else {
          hexColor = color.toString(16);
        }
        return hexColor;
      }
      return {
        value: [rgbNormalize(rgb.r), rgbNormalize(rgb.g), rgbNormalize(rgb.b)].join('')
      };
    },
    hsl(rgb) {
      const newRGB = {
        ...rgb
      };
      const hsl = {
        h: 0,
        s: 0,
        l: 0
      };
      const rgbKeys = Object.keys(newRGB);
      // eslint-disable-next-line no-restricted-syntax
      for (const rgbKey of rgbKeys) {
        newRGB[rgbKey] /= 255;
      }
      // Min Max chanel val
      const rgbChannelMinimum = Math.min(newRGB.r, newRGB.g, newRGB.b);
      const rgbChannelMaximum = Math.max(newRGB.r, newRGB.g, newRGB.b);
      const rgbChannelDelta = rgbChannelMaximum - rgbChannelMinimum;
      // Calculate hue
      if (rgbChannelDelta === 0) {
        hsl.h = 0;
      } else if (rgbChannelMaximum === newRGB.r) {
        hsl.h = Math.round((newRGB.g - newRGB.b) / rgbChannelDelta % 6 * 60);
      } else if (rgbChannelMaximum === newRGB.g) {
        hsl.h = Math.round(((newRGB.b - newRGB.r) / rgbChannelDelta + 2) * 60);
      } else {
        hsl.h = Math.round(((newRGB.r - newRGB.g) / rgbChannelDelta + 4) * 60);
      }
      // Make negative hues positive behind 360°
      hsl.h = hsl.h < 0 ? hsl.h + 360 : hsl.h;
      hsl.l = (rgbChannelMaximum + rgbChannelMinimum) / 2;
      hsl.s = rgbChannelDelta === 0 ? 0 : rgbChannelDelta / (1 - Math.abs(2 * hsl.l - 1));
      hsl.s = Math.round(hsl.s * 100);
      hsl.l = Math.round(hsl.l * 100);
      return hsl;
    },
    hsv(rgb) {
      const newRGB = {
        ...rgb
      };
      const rgbKeys = Object.keys(newRGB);
      // eslint-disable-next-line no-restricted-syntax
      for (const rgbKey of rgbKeys) {
        newRGB[rgbKey] /= 255;
      }
      const minRGB = Math.min(newRGB.r, Math.min(newRGB.g, newRGB.b));
      const maxRGB = Math.max(newRGB.r, Math.max(newRGB.g, newRGB.b));
      if (minRGB === maxRGB) {
        // grayscale
        return {
          h: 0,
          s: 0,
          v: Math.round(minRGB * 100)
        };
      }
      // color
      const d =
      // eslint-disable-next-line no-nested-ternary
      newRGB.r === minRGB ? newRGB.g - newRGB.b : newRGB.b === minRGB ? newRGB.r - newRGB.g : newRGB.b - newRGB.r;
      const h =
      // eslint-disable-next-line no-nested-ternary
      newRGB.r === minRGB ? 3 : newRGB.b === minRGB ? 1 : 5;
      return {
        h: Math.round(60 * (h - d / (maxRGB - minRGB))),
        s: Math.round((maxRGB - minRGB) / maxRGB * 100),
        v: Math.round(maxRGB * 100)
      };
    },
    lab(rgb) {
      const newRGB = {
        ...rgb
      };
      const rgbKeys = Object.keys(newRGB);
      // eslint-disable-next-line no-restricted-syntax
      for (const rgbKey of rgbKeys) {
        newRGB[rgbKey] /= 255;
      }
      newRGB.r = newRGB.r > 0.04045 ? ((newRGB.r + 0.055) / 1.055) ** 2.4 : newRGB.r / 12.92;
      newRGB.g = newRGB.g > 0.04045 ? ((newRGB.g + 0.055) / 1.055) ** 2.4 : newRGB.g / 12.92;
      newRGB.b = newRGB.b > 0.04045 ? ((newRGB.b + 0.055) / 1.055) ** 2.4 : newRGB.b / 12.92;
      const xyz = {
        x: 0,
        y: 0,
        z: 0
      };
      xyz.x = (newRGB.r * 0.4124 + newRGB.g * 0.3576 + newRGB.b * 0.1805) / 0.95047;
      xyz.y = (newRGB.r * 0.2126 + newRGB.g * 0.7152 + newRGB.b * 0.0722) / 1.00000;
      xyz.z = (newRGB.r * 0.0193 + newRGB.g * 0.1192 + newRGB.b * 0.9505) / 1.08883;
      xyz.x = xyz.x > 0.008856 ? xyz.x ** (1 / 3) : 7.787 * xyz.x + 16 / 116;
      xyz.y = xyz.y > 0.008856 ? xyz.y ** (1 / 3) : 7.787 * xyz.y + 16 / 116;
      xyz.z = xyz.z > 0.008856 ? xyz.z ** (1 / 3) : 7.787 * xyz.z + 16 / 116;
      return {
        l: 116 * xyz.y - 16,
        a: 500 * (xyz.x - xyz.y),
        b: 200 * (xyz.y - xyz.z)
      };
    },
    pantone(rgb) {
      let closestColor = null;
      let smallestDistance = Number.MAX_VALUE;
      // eslint-disable-next-line no-restricted-syntax
      for (const pantoneColor of _colorLibrary.pantone) {
        let distance;
        if (!pantoneColor.forceAs) {
          distance = Math.round(calculateDistance(rgb, pantoneColor.rgb));
        } else {
          distance = Math.min(Math.round(calculateDistance(rgb, pantoneColor.forceAs)), Math.round(calculateDistance(rgb, pantoneColor.rgb)));
        }
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestColor = pantoneColor;
        }
        if (distance === smallestDistance && closestColor && parseInt(closestColor.name, 10) > parseInt(pantoneColor.name, 10)) {
          closestColor = pantoneColor;
        }
      }
      if (closestColor) {
        return closestColor;
      }
      throw new Error(`Pantone color for RGB ${JSON.stringify(rgb)} not found`);
    },
    xyz(rgb) {
      function pivot(number) {
        return (number > 0.04045 ? ((number + 0.055) / 1.055) ** 2.4 : number / 12.92) * 100.0;
      }
      const newRGB = {
        ...rgb
      };
      const rgbKeys = Object.keys(newRGB);
      // eslint-disable-next-line no-restricted-syntax
      for (const rgbKey of rgbKeys) {
        newRGB[rgbKey] = pivot(newRGB[rgbKey] / 255.0);
      }
      return {
        x: newRGB.r * 0.4124 + newRGB.g * 0.3576 + newRGB.b * 0.1805,
        y: newRGB.r * 0.2126 + newRGB.g * 0.7152 + newRGB.b * 0.0722,
        z: newRGB.r * 0.0193 + newRGB.g * 0.1192 + newRGB.b * 0.9505
      };
    },
    yuv(rgb) {
      const yuv = {
        y: 0,
        u: 0,
        v: 0
      };
      yuv.y = 0.257 * rgb.r + 0.504 * rgb.g + 0.098 * rgb.b + 16;
      yuv.u = -0.148 * rgb.r - 0.291 * rgb.g + 0.439 * rgb.b + 128;
      yuv.v = 0.439 * rgb.r - 0.368 * rgb.g - 0.071 * rgb.b + 128;
      return yuv;
    }
  },
  xyz: {
    lab(xyz) {
      function pivot(number) {
        return number > 0.008856 ? number ** 0.3333 : (903.3 * number + 16) / 116;
      }
      const x = pivot(xyz.x / 95.047);
      const y = pivot(xyz.y / 100.000);
      const z = pivot(xyz.z / 108.883);
      return {
        l: Math.max(0, 116 * y - 16),
        a: 500 * (x - y),
        b: 200 * (y - z)
      };
    }
  },
  yuv: {
    rgb(yuv) {
      return {
        r: Math.round(yuv.y + 1.140 * yuv.v),
        g: Math.round(yuv.y - 0.395 * yuv.v - 0.581 * yuv.v),
        b: Math.round(yuv.y + 2.032 * yuv.u)
      };
    }
  }
};
function ConvertColor(options) {
  const fromType = options.from.type;
  const toType = options.to;
  if (options.from.type in colorConvert && options.to in colorConvert[options.from.type]) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return colorConvert[options.from.type][options.to](options.from.value);
  }
  throw new Error(`Conversion from ${fromType} to ${toType} is not supported`);
}